export const projectInformationStatus = {
  notReceived: "Not Received",
  received: "Received",
};

export const taxExemptCertificate = {
  exempt: "Exempt",
  notExempt: "Not Exempt",
};

export const headers = {
  jobDetails: "Job Details",
  customerDetails: "Customer Details",
  addressDetails: "Address Details",
  notes: "Notes",
};

export const jobDetailsTitles = {
  jobName: "Job Name",
  salesPerson: "Sales Person",
  projectInfoSheet: "Project Info Sheet",
  taxExemptStatus: "Tax Exempt Status",
};

export const customerDetailsTitles = {
  customerAccount: "Customer Account",
  onSiteContact: "On-site Contact",
  contactNumber: "Contact Number",
  email: "Email",
};

export const addressDetailsTitles = {
  jobSiteAddress: "Job Site Address",
  jobSiteCoordinates: "Job Site Coordinates",
};
